(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-banner"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", () => {
  const gsap = window.gsap;
  if (!gsap) {
      console.error("GSAP library not loaded.");
      return;
  }

  const topTrack = document.querySelector(".about-marquee-top .about-marquee-track");
  const bottomTrack = document.querySelector(".about-marquee-bottom .about-marquee-track");
  const topMarqueeContainer = document.querySelector(".about-marquee-top");
  const bottomMarqueeContainer = document.querySelector(".about-marquee-bottom");
  const heading = document.querySelector(".about-marquee-heading");
  
  const scrollSpeed = 35; // Speed in seconds for one full loop
  const entranceDuration = 1.0; 

  /* ----------------------------------------------------
    1. MARQUEE SCROLL AND APPEARANCE ANIMATIONS
  ---------------------------------------------------- */

  // 1. TOP MARQUEE: Right-to-Left (Scroll + Entrance)
  if (topTrack && topMarqueeContainer) {
    // Entrance
    gsap.to(topMarqueeContainer, { 
        scale: 1, 
        opacity: 1, 
        duration: entranceDuration, 
        ease: "power2.out", 
        delay: 0.2 
    });
    
    // Seamless Scroll (x: 0% to x: -50%)
    gsap.fromTo(
      topTrack,
      { x: '0%' }, 
      {
        x: '-50%', 
        duration: scrollSpeed,
        ease: 'linear',
        repeat: -1,
        immediateRender: false,
        delay: 0.2 // Starts scroll with the entrance
      }
    );
  }

  // 2. BOTTOM MARQUEE: Left-to-Right (Scroll + Entrance)
  if (bottomTrack && bottomMarqueeContainer) {
    // Entrance
    gsap.to(bottomMarqueeContainer, { 
        scale: 1, 
        opacity: 1, 
        duration: entranceDuration, 
        ease: "power2.out", 
        delay: 0.4 
    });
    
    // Seamless Scroll (x: -50% to x: 0%)
    gsap.fromTo(
      bottomTrack,
      { x: '-50%' }, // Start offset
      {
        x: '0%', // End position
        duration: scrollSpeed,
        ease: 'linear',
        repeat: -1,
        immediateRender: false,
        delay: 0.4 // Starts scroll with the entrance
      }
    );
  }

  /* ----------------------------------------------------
    2. HEADING WORD ANIMATION
  ---------------------------------------------------- */
  if (heading) {
    const words = heading.textContent.split(" ");
    
    // Split text into nested spans for the overflow/slide effect
    heading.innerHTML = words
      .map(w => `<span class="word-wrapper"><span class="word-inner">${w}</span></span>`)
      .join(" ");

    const innerWords = heading.querySelectorAll(".word-inner");
    
    const tl = gsap.timeline({ defaults: { ease: 'power3.out' } });

    // A) Reveal the H1 container (from opacity: 0 set in CSS)
    tl.set(heading, { opacity: 1 }, 0.4); 

    // B) Staggered word animation (from yPercent: 100 up to 0)
    tl.from(innerWords, {
      yPercent: 100,
      duration: 0.9,
      stagger: 0.06
    }, 0.4); // Starts simultaneously with the H1 reveal
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["banner-carousel"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // IMPORTANT: use the exact id used in the section HTML
    const carousel = document.querySelector('.hero-carousel');
    if (!carousel) return;

    const slides = Array.from(carousel.querySelectorAll('.carousel-slide'));
    const dots = Array.from(carousel.querySelectorAll('.carousel-dot'));
    const prev = carousel.querySelector('.carousel-prev');
    const next = carousel.querySelector('.carousel-next');

    let currentIndex = slides.findIndex((s) => s.classList.contains('is-active'));
    if (currentIndex === -1) currentIndex = 0;

    let interval = null;
    const autoplayDelay = 5000;

    function setActiveDot(index) {
      dots.forEach((d, i) => d.classList.toggle('is-active', i === index));
    }

    function showSlide(index, { animate = true } = {}) {
      const newIndex = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === newIndex);
      });
      currentIndex = newIndex;
      if (dots.length) setActiveDot(currentIndex);
    }

    function nextSlide() {
      showSlide(currentIndex + 1);
    }
    function prevSlide() {
      showSlide(currentIndex - 1);
    }

    function startAutoplay() {
      stopAutoplay();
      interval = setInterval(nextSlide, autoplayDelay);
    }

    function stopAutoplay() {
      if (interval !== null) {
        clearInterval(interval);
        interval = null;
      }
    }

    // Event listeners for controls (guard against absence)
    if (next) {
      next.addEventListener('click', function (e) {
        e.preventDefault();
        nextSlide();
        stopAutoplay();
      });
    }

    if (prev) {
      prev.addEventListener('click', function (e) {
        e.preventDefault();
        prevSlide();
        stopAutoplay();
      });
    }

    dots.forEach((dot, idx) => {
      dot.addEventListener('click', function (e) {
        e.preventDefault();
        showSlide(idx);
        stopAutoplay();
      });
    });

    // Pause on hover/focus for accessibility
    carousel.addEventListener('mouseenter', stopAutoplay);
    carousel.addEventListener('mouseleave', startAutoplay);
    carousel.addEventListener('focusin', stopAutoplay);
    carousel.addEventListener('focusout', startAutoplay);

    // Keyboard navigation (left / right)
    carousel.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') {
        nextSlide();
        stopAutoplay();
      }
      if (e.key === 'ArrowLeft') {
        prevSlide();
        stopAutoplay();
      }
    });

    // Ensure the first slide/dot is set correctly on init
    showSlide(currentIndex, { animate: false });

    // Start autoplay only if more than 1 slide
    if (slides.length > 1) startAutoplay();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const header = document.getElementById('site-header');
  if (!header) return;

  /* ── SCROLL SHOW / HIDE ── */
  let lastScrollY = window.scrollY;
  let ticking = false;
  const THRESHOLD = 80;

  function updateHeader() {
    const y = window.scrollY;
    const scrollingDown = y > lastScrollY;
    if (y < THRESHOLD) {
      header.classList.remove('is-hidden');
      header.classList.add('is-visible');
    } else if (scrollingDown) {
      header.classList.add('is-hidden');
      header.classList.remove('is-visible');
      closeMega();
    } else {
      header.classList.remove('is-hidden');
      header.classList.add('is-visible');
    }
    lastScrollY = y;
    ticking = false;
  }

  window.addEventListener('scroll', () => {
    if (!ticking) { requestAnimationFrame(updateHeader); ticking = true; }
  }, { passive: true });

  requestAnimationFrame(() => header.classList.add('is-visible'));

  /* ── MEGA MENU ── */
  const menuItems      = Array.from(header.querySelectorAll('.menu-item.has-children'));
  const megaTriggers   = Array.from(header.querySelectorAll('.menu-link-wrap--button'));
  const megaPanels     = Array.from(header.querySelectorAll('.mega-panel'));
  let activeIndex      = null;
  let closeTimeout     = null;

  function openMega(index) {
    clearTimeout(closeTimeout);
    if (activeIndex === index) return;

    // Close any currently open panel
    megaPanels.forEach(p => { p.hidden = true; });
    megaTriggers.forEach(t => {
      t.setAttribute('aria-expanded', 'false');
      t.closest('.menu-item').classList.remove('is-active');
    });

    const panel   = header.querySelector(`.mega-panel[data-mega="${index}"]`);
    const trigger = megaTriggers[index];
    if (!panel || !trigger) return;

    // Measure height before showing
    panel.style.visibility = 'hidden';
    panel.hidden = false;
    const panelH = panel.offsetHeight;
    panel.style.visibility = '';

    header.style.setProperty('--mega-height', (70 + panelH) + 'px');
    header.classList.add('mega-open');
    trigger.setAttribute('aria-expanded', 'true');
    trigger.closest('.menu-item').classList.add('is-active');
    activeIndex = index;
  }

  function closeMega() {
    clearTimeout(closeTimeout);
    header.classList.remove('mega-open');
    megaTriggers.forEach(t => {
      t.setAttribute('aria-expanded', 'false');
      t.closest('.menu-item').classList.remove('is-active');
    });
    closeTimeout = setTimeout(() => {
      megaPanels.forEach(p => { p.hidden = true; });
      activeIndex = null;
    }, 350);
  }

  // Mouse interactions — unchanged behaviour
  menuItems.forEach((item, i) => {
    item.addEventListener('mouseenter', () => openMega(i));
    item.addEventListener('mouseleave', () => {
      closeTimeout = setTimeout(closeMega, 80);
    });
  });

  megaPanels.forEach(panel => {
    panel.addEventListener('mouseenter', () => clearTimeout(closeTimeout));
    panel.addEventListener('mouseleave', () => closeMega());
  });

  header.querySelectorAll('.menu-item:not(.has-children)').forEach(item => {
    item.addEventListener('mouseenter', () => closeMega());
  });

  megaTriggers.forEach((trigger, i) => {
    trigger.addEventListener('click', () => {
      if (activeIndex === i) {
        closeMega();
      } else {
        openMega(i);
      }
    });

    trigger.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        closeMega();
        trigger.focus();
      }
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        openMega(i);
        const panel = header.querySelector(`.mega-panel[data-mega="${i}"]`);
        const firstFocusable = panel?.querySelector('a, button');
        firstFocusable?.focus();
      }
    });
  });

  // Remove the entire megaPanels keydown block and replace with this:
  megaPanels.forEach((panel, i) => {
    panel.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        closeMega();
        megaTriggers[i]?.focus();
      }
    });
  });

  // Close mega when focus leaves the header entirely
  header.addEventListener('focusout', (e) => {
    // relatedTarget is where focus is going — if it's outside the header, close
    if (!header.contains(e.relatedTarget)) {
      closeMega();
    }
  });

  /* ── BURGER / MOBILE MENU ── */
  const burger = header.querySelector('.header-burger');
  const mobile = header.querySelector('#mobile-menu');

  burger?.addEventListener('click', function () {
    const expanded = this.getAttribute('aria-expanded') === 'true';
    const opening  = !expanded;
    this.setAttribute('aria-expanded', String(opening));
    this.setAttribute('aria-label', opening ? 'Close navigation menu' : 'Open navigation menu');
    if (mobile) mobile.hidden = !opening;
    // Move focus into menu when opening
    if (opening) {
      const firstFocusable = mobile.querySelector('a, button');
      firstFocusable?.focus();
    }
  });

  /* ── GLOBAL ESCAPE ── */
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') {
      if (activeIndex !== null) {
        const idx = activeIndex;
        closeMega();
        megaTriggers[idx]?.focus();
      }
      if (mobile && !mobile.hidden) {
        mobile.hidden = true;
        burger?.setAttribute('aria-expanded', 'false');
        burger?.setAttribute('aria-label', 'Open navigation menu');
        burger?.focus();
      }
    }
  });

  /* ── CLICK OUTSIDE ── */
  document.addEventListener('click', (e) => {
    if (activeIndex !== null && !header.contains(e.target)) {
      closeMega();
    }
  });

  /* ── MOBILE ACCORDION ── */
  header.querySelectorAll('.mobile-menu-link--accordion').forEach((button) => {
    button.addEventListener('click', () => {
      const expanded = button.getAttribute('aria-expanded') === 'true';
      const submenu  = document.getElementById(button.getAttribute('aria-controls'));

      // Close all others
      header.querySelectorAll('.mobile-menu-link--accordion').forEach((other) => {
        if (other !== button) {
          other.setAttribute('aria-expanded', 'false');
          const otherSubmenu = document.getElementById(other.getAttribute('aria-controls'));
          if (otherSubmenu) otherSubmenu.classList.remove('is-open');
          other.closest('.mobile-menu-item').classList.remove('is-open');
        }
      });

      button.setAttribute('aria-expanded', String(!expanded));
      if (submenu) submenu.classList.toggle('is-open', !expanded);
      button.closest('.mobile-menu-item').classList.toggle('is-open', !expanded);
    });

    // Arrow keys within mobile accordion
    button.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        const expanded = button.getAttribute('aria-expanded') === 'true';
        if (!expanded) button.click(); // open it
        const submenu = document.getElementById(button.getAttribute('aria-controls'));
        submenu?.querySelector('a')?.focus();
      }
      if (e.key === 'Escape') {
        const expanded = button.getAttribute('aria-expanded') === 'true';
        if (expanded) button.click(); // close it
        button.focus();
      }
    });
  });

  // Escape from mobile submenu links closes the accordion
  header.querySelectorAll('.mobile-submenu').forEach((submenu) => {
    submenu.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        submenu.classList.remove('is-open');
        const trigger = header.querySelector(`[aria-controls="${submenu.id}"]`);
        if (trigger) {
          trigger.setAttribute('aria-expanded', 'false');
          trigger.closest('.mobile-menu-item').classList.remove('is-open');
          trigger.focus();
        }
      }
    });
  });

});

/* ── CART COUNT ── */
// document.addEventListener('DOMContentLoaded', () => {
//   const updateCartUI = (count) => {
//     document.querySelectorAll('.cart-count').forEach(el => {
//       el.textContent = count;
//     });
//     document.querySelectorAll('.cart-count-badge').forEach(el => {
//       el.hidden = count === 0;
//     });
//     // Keep cart link aria-label in sync
//     document.querySelectorAll('.cart-icon-container').forEach(el => {
//       el.setAttribute('aria-label',
//         count === 0
//           ? 'Shopping cart'
//           : `Shopping cart, ${count} item${count > 1 ? 's' : ''}`
//       );
//     });
//   };

//   const refreshCart = () => {
//     fetch('/cart.js')
//       .then(r => r.json())
//       .then(cart => updateCartUI(cart.item_count))
//       .catch(() => {});
//   };

//   refreshCart();

//   new MutationObserver(() => refreshCart()).observe(document.body, {
//     childList: true,
//     subtree: true
//   });
// });

/* ── CART COUNT ── */
document.addEventListener('DOMContentLoaded', () => {
  const updateCartUI = (count) => {
    document.querySelectorAll('.cart-count').forEach(el => {
      el.textContent = count;
    });
    document.querySelectorAll('.cart-count-badge').forEach(el => {
      el.hidden = count === 0;
    });
    document.querySelectorAll('.cart-icon-container').forEach(el => {
      el.setAttribute('aria-label',
        count === 0
          ? 'Shopping cart'
          : `Shopping cart, ${count} item${count > 1 ? 's' : ''}`
      );
    });
  };

  const refreshCart = () => {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => updateCartUI(cart.item_count))
      .catch(() => {});
  };

  refreshCart(); // initial paint on load
  document.addEventListener('cart:refresh', refreshCart); // update only when cart actually changes
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multi-subsection"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.msp-add-to-cart-form').forEach(form => {
    const button = form.querySelector('.msp-add-to-cart-btn');
    if (!button) return;

    const variantId = button.dataset.variantId;
    if (!variantId) return;

    let quantity = 0;

    function renderQuantitySelector() {
      form.innerHTML = `
        <div class="msp-quantity-selector">
          <button type="button" class="msp-qty-btn msp-qty-minus">−</button>
          <span class="msp-qty-count">${quantity}</span>
          <button type="button" class="msp-qty-btn msp-qty-plus">+</button>
        </div>
      `;

      form.querySelector('.msp-qty-minus').addEventListener('click', () => updateQty(-1));
      form.querySelector('.msp-qty-plus').addEventListener('click', () => updateQty(1));
    }

    function renderAddToCart() {
      form.innerHTML = `
        <button
          type="button"
          class="base-button msp-add-to-cart-btn cta-purple"
          data-variant-id="${variantId}"
        >
          <h6 class="msp-add-to-cart-text">Add to Cart</h6>
          <div class="msp-cta-icon-container">
            <svg class="msp-cta-icon" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false">
              <path fill="currentColor" d="M12 4l1.41 1.41L8.83 10H20v2H8.83l4.58 4.59L12 18l-8-8z"/>
            </svg>
          </div>
        </button>
      `;
      form.querySelector('.msp-add-to-cart-btn').addEventListener('click', handleAddToCart);
    }

    async function updateQty(delta) {
      const newQty = quantity + delta;

      if (newQty <= 0) {
        quantity = 0;
        renderAddToCart();
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 0 })
        });
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        return;
      }

      quantity = newQty;
      form.querySelector('.msp-qty-count').textContent = quantity;

      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity })
      });
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    }

    async function handleAddToCart() {
      const btn = form.querySelector('.msp-add-to-cart-btn');
      btn.disabled = true;
      form.querySelector('.msp-add-to-cart-text').textContent = 'Adding...';

      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });

        quantity = 1;
        renderQuantitySelector();
        document.dispatchEvent(new CustomEvent('cart:refresh'));

      } catch (err) {
        console.error('Cart error:', err);
        btn.disabled = false;
        form.querySelector('.msp-add-to-cart-text').textContent = 'Add to Cart';
      }
    }

    button.addEventListener('click', handleAddToCart);

    // On page load, check cart and restore quantity selectors
    async function syncCartState() {
      try {
        const res = await fetch('/cart.js');
        const cart = await res.json();

        document.querySelectorAll('.msp-add-to-cart-form').forEach(f => {
          const btn = f.querySelector('.msp-add-to-cart-btn');
          if (!btn) return;

          const vId = btn.dataset.variantId;
          if (!vId) return;

          const cartItem = cart.items.find(item => String(item.variant_id) === String(vId));

          if (cartItem && cartItem.quantity > 0) {
            const event = new CustomEvent('msp:restoreQty', {
              detail: { form: f, variantId: vId, quantity: cartItem.quantity }
            });
            document.dispatchEvent(event);
          }
        });
      } catch (err) {
        console.error('Cart sync error:', err);
      }
    }

    document.addEventListener('msp:restoreQty', (e) => {
      const { form: f, variantId: vId, quantity: initialQty } = e.detail;
      let qty = initialQty;

      function renderQtySelector() {
        f.innerHTML = `
          <div class="msp-quantity-selector">
            <button type="button" class="msp-qty-btn msp-qty-minus">−</button>
            <span class="msp-qty-count">${qty}</span>
            <button type="button" class="msp-qty-btn msp-qty-plus">+</button>
          </div>
        `;
        f.querySelector('.msp-qty-minus').addEventListener('click', () => updateQtyRestore(-1));
        f.querySelector('.msp-qty-plus').addEventListener('click', () => updateQtyRestore(1));
      }

      function renderAddToCartRestore() {
        f.innerHTML = `
          <button
            type="button"
            class="base-button msp-add-to-cart-btn cta-purple"
            data-variant-id="${vId}"
          >
            <h6 class="msp-add-to-cart-text">Add to Cart</h6>
            <div class="msp-cta-icon-container">
              <svg class="msp-cta-icon" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false">
                <path fill="currentColor" d="M12 4l1.41 1.41L8.83 10H20v2H8.83l4.58 4.59L12 18l-8-8z"/>
              </svg>
            </div>
          </button>
        `;
      }

      async function updateQtyRestore(delta) {
        const newQty = qty + delta;

        if (newQty <= 0) {
          qty = 0;
          renderAddToCartRestore();
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: vId, quantity: 0 })
          });
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          return;
        }

        qty = newQty;
        f.querySelector('.msp-qty-count').textContent = qty;
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: vId, quantity: qty })
        });
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      }

      renderQtySelector();
    });

    syncCartState();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-all-product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.ap-add-to-cart-form').forEach(form => {
  const button = form.querySelector('.ap-add-to-cart-btn');
  if (!button) return;

  const variantId = button.dataset.variantId;
  if (!variantId) return;

  let quantity = 0;

  function renderQuantitySelector() {
    form.innerHTML = `
      <div class="ap-quantity-selector">
        <button type="button" class="ap-qty-btn ap-qty-minus">−</button>
        <span class="ap-qty-count">${quantity}</span>
        <button type="button" class="ap-qty-btn ap-qty-plus">+</button>
      </div>
    `;

    form.querySelector('.ap-qty-minus').addEventListener('click', () => updateQty(-1));
    form.querySelector('.ap-qty-plus').addEventListener('click', () => updateQty(1));
  }

  function renderAddToCart() {
    form.innerHTML = `
      <button
        type="button"
        class="base-button ap-add-to-cart-btn cta-purple"
        data-variant-id="${variantId}"
      >
        <h6 class="ap-add-to-cart-text">Add to Cart</h6>
        <div class="ap-cta-icon-container">
          <svg class="ap-cta-icon" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false">
            <path fill="currentColor" d="M12 4l1.41 1.41L8.83 10H20v2H8.83l4.58 4.59L12 18l-8-8z"/>
          </svg>
        </div>
      </button>
    `;
    form.querySelector('.ap-add-to-cart-btn').addEventListener('click', handleAddToCart);
  }

  async function updateQty(delta) {
    const newQty = quantity + delta;

    if (newQty <= 0) {
      quantity = 0;
      renderAddToCart();
      // remove from cart
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 0 })
      });
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      return;
    }

    quantity = newQty;
    form.querySelector('.ap-qty-count').textContent = quantity;

    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity })
    });
    document.dispatchEvent(new CustomEvent('cart:refresh'));
  }

  async function handleAddToCart() {
    const btn = form.querySelector('.ap-add-to-cart-btn');
    btn.disabled = true;
    form.querySelector('.ap-add-to-cart-text').textContent = 'Adding...';

    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });

      quantity = 1;
      renderQuantitySelector();
      document.dispatchEvent(new CustomEvent('cart:refresh'));

    } catch (err) {
      console.error('Cart error:', err);
      btn.disabled = false;
      form.querySelector('.ap-add-to-cart-text').textContent = 'Add to Cart';
    }
  }

  button.addEventListener('click', handleAddToCart);


  // On page load, check cart and restore quantity selectors
async function syncCartState() {
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();

    document.querySelectorAll('.ap-add-to-cart-form').forEach(form => {
      const button = form.querySelector('.ap-add-to-cart-btn');
      if (!button) return;

      const variantId = button.dataset.variantId;
      if (!variantId) return;

      // Find this variant in the current cart
      const cartItem = cart.items.find(item => String(item.variant_id) === String(variantId));

      if (cartItem && cartItem.quantity > 0) {
        // Product is already in cart — swap to quantity selector
        // We need to re-trigger the same logic, so dispatch a synthetic "already added" state
        const event = new CustomEvent('ap:restoreQty', {
          detail: { form, variantId, quantity: cartItem.quantity }
        });
        document.dispatchEvent(event);
      }
    });
  } catch (err) {
    console.error('Cart sync error:', err);
  }
}

document.addEventListener('ap:restoreQty', (e) => {
  const { form, variantId, quantity: initialQty } = e.detail;
  let quantity = initialQty;

  function renderQuantitySelector() {
    form.innerHTML = `
      <div class="ap-quantity-selector">
        <button type="button" class="ap-qty-btn ap-qty-minus">−</button>
        <span class="ap-qty-count">${quantity}</span>
        <button type="button" class="ap-qty-btn ap-qty-plus">+</button>
      </div>
    `;
    form.querySelector('.ap-qty-minus').addEventListener('click', () => updateQty(-1));
    form.querySelector('.ap-qty-plus').addEventListener('click', () => updateQty(1));
  }

  function renderAddToCart() {
    form.innerHTML = `
      <button
        type="button"
        class="base-button ap-add-to-cart-btn cta-purple"
        data-variant-id="${variantId}"
      >
        <h6 class="ap-add-to-cart-text">Add to Cart</h6>
        <div class="ap-cta-icon-container">
          <svg class="ap-cta-icon" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false">
            <path fill="currentColor" d="M12 4l1.41 1.41L8.83 10H20v2H8.83l4.58 4.59L12 18l-8-8z"/>
          </svg>
        </div>
      </button>
    `;
  }

  async function updateQty(delta) {
    const newQty = quantity + delta;

    if (newQty <= 0) {
      quantity = 0;
      renderAddToCart();
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 0 })
      });
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      return;
    }

    quantity = newQty;
    form.querySelector('.ap-qty-count').textContent = quantity;
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity })
    });
    document.dispatchEvent(new CustomEvent('cart:refresh'));
  }

  renderQuantitySelector();
});

syncCartState();







});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-bestseller"] && !Shopify.designMode) return;
  try {
    
  function initBestSellersCart() {

  function makeQuantitySelector(form, variantId, initialQty) {
    let quantity = initialQty;

    function renderQuantitySelector() {
      form.innerHTML = `
        <div class="bs-quantity-selector">
          <button type="button" class="bs-qty-btn bs-qty-minus">−</button>
          <span class="bs-qty-count">${quantity}</span>
          <button type="button" class="bs-qty-btn bs-qty-plus">+</button>
        </div>
      `;
      form.querySelector('.bs-qty-minus').addEventListener('click', () => updateQty(-1));
      form.querySelector('.bs-qty-plus').addEventListener('click', () => updateQty(1));
    }

    function renderAddToCart() {
      form.innerHTML = `
        <button
          type="button"
          class="base-button add-to-cart-btn cta-purple"
          data-variant-id="${variantId}"
        >
          <h6 class="add-to-cart-btn-text">Add to Cart</h6>
          <div class="add-to-cart-cta__icon_container cta__icon_container">
            <svg class="banner-cta__icon" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false">
              <path fill="currentColor" d="M12 4l1.41 1.41L8.83 10H20v2H8.83l4.58 4.59L12 18l-8-8z"/>
            </svg>
          </div>
        </button>
      `;
      form.querySelector('.add-to-cart-btn').addEventListener('click', handleAddToCart);
    }

    async function updateQty(delta) {
      const newQty = quantity + delta;

      if (newQty <= 0) {
        quantity = 0;
        renderAddToCart();
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 0 })
        });
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        return;
      }

      quantity = newQty;
      form.querySelector('.bs-qty-count').textContent = quantity;
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity })
      });
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    }

    async function handleAddToCart() {
      const btn = form.querySelector('.add-to-cart-btn');
      btn.disabled = true;
      form.querySelector('.add-to-cart-btn-text').textContent = 'Adding...';

      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });

        quantity = 1;
        renderQuantitySelector();
        document.dispatchEvent(new CustomEvent('cart:refresh'));

      } catch (err) {
        console.error('Cart error:', err);
        btn.disabled = false;
        form.querySelector('.add-to-cart-btn-text').textContent = 'Add to Cart';
      }
    }

    renderQuantitySelector();
  }

  // Attach click handler to initial Add to Cart buttons
  document.querySelectorAll('.best-sellers-add-to-cart-form').forEach(form => {
    const button = form.querySelector('[data-variant-id]');
    if (!button) return;

    const variantId = button.dataset.variantId;
    if (!variantId) return;

    button.addEventListener('click', async () => {
      button.disabled = true;
      button.querySelector('.add-to-cart-btn-text').textContent = 'Adding...';

      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });

        makeQuantitySelector(form, variantId, 1);
        document.dispatchEvent(new CustomEvent('cart:refresh'));

      } catch (err) {
        console.error('Cart error:', err);
        button.disabled = false;
        button.querySelector('.add-to-cart-btn-text').textContent = 'Add to Cart';
      }
    });
  });

  // On page load — sync with real cart state
  async function syncCartState() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();

      document.querySelectorAll('.best-sellers-add-to-cart-form').forEach(form => {
        const button = form.querySelector('[data-variant-id]');
        if (!button) return;

        const variantId = button.dataset.variantId;
        if (!variantId) return;

        const cartItem = cart.items.find(item => String(item.variant_id) === String(variantId));
        if (cartItem && cartItem.quantity > 0) {
          makeQuantitySelector(form, variantId, cartItem.quantity);
        }
      });
    } catch (err) {
      console.error('Cart sync error:', err);
    }
  }

  syncCartState();
}

initBestSellersCart();

  } catch(e) { console.error(e); }
})();
})();
